<template>
  <div>
    <div id="connection-control" class="clearfix">
      <div class="btn btn-sm btn-outline-primary float-right position-relative">
        <vue-file @change="importConnection" type="Object" class="file position-absolute w-100 h-100"></vue-file>
        <i class="fa fa-folder-open-o" aria-hidden="true"></i>
        导入
      </div>
    </div>
    <div>
      <global-forms id="forms"></global-forms>
    </div>
  </div>
</template>

<script>
  import { GlobalManager } from '@/components/home/controllers/global'
  import Forms from '@/components/home/forms'
  import db from '@/extensions/db'
  import VueFile from '@/components/utils/vue-file'

  export default {
    data () {
      return {}
    },
    created () {
      this._globalManager = new GlobalManager(this)

      this._imported = () => {
        this._globalManager.editUploadConfig()
      }

      this.$emitter.on('imported', this._imported)
      this.$emitter.on('updateMetadata', this._imported)
      this._globalManager.editUploadConfig()
    },
    destroyed () {
      this.$emitter.removeListener('imported', this._imported)
      this.$emitter.removeListener('updateMetadata', this._imported)
    },
    components: {
      'global-forms': Forms,
      VueFile
    },
    methods: {
      async importConnection (name, data) {
        await db.loadConnection(data)
      }
    }
  }
</script>

<style>
  #connection-control {
    margin-bottom: 1rem;
  }

  #connection-control > .btn {
    margin-left: 0.5rem;
  }

  #connection-control .file {
    top: 0;
    left: 0;
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/tabs/upload.vue